<router-outlet></router-outlet>
<uni-loader *ngIf="isLoaderActive" [isFullScreen]="true"></uni-loader>
